import {useAppSelector} from '@/hooks';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import type {TranscriptItemObject} from '@PosterWhiteboard/items/transcript-item/transcript-item.types';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {SerializedShadowOptions} from '@postermywall/fabricjs-2';

export function useGetKeyFromSubtitleShadowPropertiesForActiveTranscriptItem<T extends keyof SerializedShadowOptions>(key: T): SerializedShadowOptions[T] | undefined | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const itemObject = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];
    if (!itemObject) {
      return undefined;
    }

    if (itemObject.gitype !== ITEM_TYPE.TRANSCRIPT) {
      throw new Error(`Item isn't a transcript item`);
    }

    const transcriptItemObject = itemObject as TranscriptItemObject;
    const anySubtitleShadowObject = Object.values(transcriptItemObject.subtitlesHashmap)[0].shadow;

    if (!anySubtitleShadowObject) {
      return null;
    }

    if (anySubtitleShadowObject[key] !== undefined) {
      return anySubtitleShadowObject[key];
    }

    return undefined;
  });
}
